import Menu from '../components/Menu.jsx'
import useExtentedMenuItems from './useExtentedMenuItems'
import useMenuItemModel from './useMenuItemModel.jsx'
import useMenuItemPlatform from './useMenuItemPlatform.jsx'
import useMenuItemProject from './useMenuItemProject.jsx'
import useMenuItemPattern from './useMenuItemPattern.jsx'
import useMenuItemTeam from './useMenuItemTeam.jsx'
import useMenuItemTemplate from './useMenuItemTemplate.jsx'
import useMenuItemUser from './useMenuItemUser.jsx'

export default function MainMenu(props) {
    const items = [
        useMenuItemProject(),
        useMenuItemModel(),
        useMenuItemPattern(),
        useMenuItemTemplate(),
        useMenuItemTeam(),
        useMenuItemPlatform(),
        ...useExtentedMenuItems(),
        useMenuItemUser(),
    ]

    return (
        <Menu
            items={items}
            {...props}
        />
    )
}
